export const isAdmin = user => {
  return user.data.isAdmin || user.data.isSuperAdmin
}

export const isSuperAdmin = user => {
  return user.data.isSuperAdmin
}
